
export const InformacionOscForm = {
    idFiguraLegal: {
        value: '',
        required: true,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },
    idTipoInstitucion: {
        value: '',
        required: true,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },
    idCatEstatusCluni: {
        value: '',
        required: false,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },
    idTipoPoblacion: {
        value: '',
        required: true,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },
    cluni: {
        value: '',
        required: false,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },
    fechaPublicacion: {
        value: '',
        required: false,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },

    isDonataria: {
        value: '0',
        required: true,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },

    isCluni: {
        value: '0',
        required: true,
        message: 'Dato requerido',
        tool: '',
        invalid: false,
    },
}

export const siNoCatalogo = [
    {
        label: "Si",
        value: 1
    },
    {
        label: "No",
        value: 0
    }
]